//Modules
import { Fragment } from 'react'

//Components
import AreasCientificas from './AreasCientificas'

//Constants
import { details } from '../../../constants/cursos'

function RamoOuPlanoNovo({ plano, planoNovo, lang }) {
    if (plano.$.ramo !== "") {
        return <p className='course-title-detail'><strong>{details.ramo[lang]}: </strong>{plano.$.ramo}</p>;
    } else if (planoNovo) {
        return <p className='course-title-detail'><strong>{details.planoNovo[lang]}</strong></p>;
    }
}

function PlanoEstudos({ plano, index, planoCount, lang }) {

  return (
    <>
        <article className='my-5'>
            <div className="container page">
                <div className="row">
                    <div className="col-md-12">
                        <RamoOuPlanoNovo plano={ plano } planoNovo={ planoCount > 1 && index === (planoCount - 1) } lang={lang} />
                    </div>
                </div>
            </div>
        </article>
        {plano.areas[0]?.area && <AreasCientificas areas={plano.areas[0].area} lang={lang} />}
        <article className='my-5'>
            <div className="container page">
                <div className="row">
                    <div className="col-md-12">                    
                        <p className='course-title-detail'><strong>{details.plano[lang]}</strong></p>
                        <table className='plano-estudos-detail'>
                            <caption class="sr-only" style={{color: 'white'}}>Plano de Estudos</caption>
                            <thead>
                                <tr>
                                    <th scope="col"><strong>{details.headerPlano.codigo[lang]}</strong></th>
                                    <th scope="col"><strong>{details.headerPlano.unidade[lang]}</strong></th>
                                    <th scope="col"><strong>{details.headerPlano.ano[lang]}</strong></th>
                                    <th scope="col"><strong>{details.headerPlano.tipo[lang]}</strong></th>
                                    <th scope="col"><strong>{details.headerPlano.area[lang]}</strong></th>
                                    <th scope="col"><strong>{details.headerPlano.ects[lang]}</strong></th>
                                </tr>
                            </thead>
                            <tbody>
                                {plano.plano_estudos[0].uc.map((uc) => (  
                                    <Fragment key={uc.$.n_disciplina}>                              
                                        {uc.$.opcao === "false" ?
                                            <tr>
                                                <td>{uc.$.codigo}</td>
                                                <td>
                                                    {uc.$.url ? <a href={uc.$.url} target="_blank" rel="noreferrer">{uc.$.nome}</a> : uc.$.nome}
                                                </td>
                                                <td>{uc.$.ano}</td>
                                                <td>{"S"+uc.$.semestre}</td>
                                                <td>{uc?.area ? 
                                                    uc.area.map((area, index) => (
                                                        <span key={index}>{area.$.nome}<strong style={{color: "#933cc5"}}>{index !== uc.area.length - 1 ? " | " : ""}</strong></span>
                                                    ))
                                                    : ""}</td>
                                                <td>{uc.$.ects}</td>
                                            </tr>
                                            :  
                                            <tr>
                                                <td colSpan={6} className='opcao'>
                                                    <div className="accordion plano opcao">
                                                        <div className="card cardAccordion">
                                                            <div className="card-header" id={uc.$.nome.replaceAll(" ", "-")}>
                                                                <button className="btn collapsed" type="button" data-toggle="collapse" data-target={`#collapse-${uc.$.nome.replaceAll(" ", "-")}`} aria-expanded="false" aria-controls={`collapse-${uc.$.nome.replaceAll(" ", "-")}`}>
                                                                    <strong>{uc.$.nome}</strong>
                                                                    <span></span>
                                                                </button>
                                                            </div>

                                                            <div id={`collapse-${uc.$.nome.replaceAll(" ", "-")}`} className="collapse" >
                                                                <div className="card-body">
                                                                    <table>
                                                                        <caption class="sr-only" style={{color: '#fafafa'}}>Opção</caption>
                                                                        <thead class="sr-only">
                                                                            <tr>
                                                                                <th scope="col">Código</th>
                                                                                <th scope="col">Unidade Curricular</th>
                                                                                <th scope="col">Ano</th>
                                                                                <th scope="col">Semestre</th>
                                                                                <th scope="col">Área</th>
                                                                                <th scope="col">ECTS</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                        {uc.opcao.map((op, index) => (                                                                        
                                                                            <tr key={op.$.codigo} className={index === uc.opcao.length - 1 ? "no-border" : ""}> 
                                                                                <td width="20%">{op.$.codigo}</td>
                                                                                <td width="47.7%"><a href={op.$.url} target="_blank" rel="noreferrer">{op.$.nome}</a></td>
                                                                                <td width="5.4%">{uc.$.ano}</td>
                                                                                <td width="5.89%">{"S"+uc.$.semestre}</td>
                                                                                <td width="14.6%">{uc?.area ? uc.area[0].$.nome : ""}</td>
                                                                                <td>{uc.$.ects}</td>
                                                                            </tr>
                                                                        ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>                                        
                                            </tr>                                    
                                        }
                                    </Fragment>
                                ))}
                            </tbody>
                        </table>                        
                    </div>
                </div>
            </div>
        </article>
        {index !== planoCount-1 && <hr />}
    </>
  )
}

export default PlanoEstudos